import { z } from "zod"

import type { MdxModule } from "@/mdx"

export const postModules = import.meta.glob<MdxModule>("./*.mdx", {
  eager: true,
})

/** False while the blog has no posts: the nav, sitemap and llms.txt then leave `/blog` out. */
export const hasPublishedPosts = Object.keys(postModules).length > 0

export const blogPostAuthorSchema = z.object({
  name: z.string(),
  role: z.string().optional(),
  imageSrc: z.string().optional(),
  url: z.string().optional(),
})

export const blogPostFrontmatterSchema = z.object({
  title: z.string(),
  description: z.string(),
  keywords: z.array(z.string()).optional(),
  date: z.iso.date(),
  dateModified: z.iso.date().optional(),
  imgSrc: z.string(),
  author: blogPostAuthorSchema,
})
